<template>
    <div>
      <div v-if="productDescription">
        Description provided
      </div>
      <div v-else style="color: var(--v-darkGrayColor-base); font-weight: normal;">
        No description provided
      </div>
    </div>
</template>

<script>
export default {
    name: 'ConfigPreviewProductDescription',
    props: [
        'productDescription',
    ],
    computed: {

    }
}
</script>

<style lang="scss" scoped>

</style>